import { c as _c } from "react/compiler-runtime";
import { FeatherCheckCheck } from '@subframe/core';
import type { IdentificacaoSentenca } from '../../../types/sentencaArbitral.types';
interface FaixaAutenticidadeSentencaProps {
  identificacao: Pick<IdentificacaoSentenca, 'autenticidadeUrl' | 'autenticidadeUrlExibicao'>;
  codigoAutenticacao: string;
}
export function FaixaAutenticidadeSentenca(t0) {
  const $ = _c(11);
  const {
    identificacao,
    codigoAutenticacao
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="bg-brand-600/10 text-brand-600 flex h-7 w-7 flex-none items-center justify-center rounded-[7px]"><FeatherCheckCheck className="h-4 w-4" /></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <strong className="text-brand-600">Autenticidade:</strong>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== identificacao.autenticidadeUrl || $[3] !== identificacao.autenticidadeUrlExibicao) {
    t3 = <div className="min-w-[220px] flex-1 text-[12.5px] leading-[1.5] text-neutral-700">{t2} acesse{" "}<a className="text-brand-600 font-bold hover:underline" href={identificacao.autenticidadeUrl} rel="noopener noreferrer" target="_blank">{identificacao.autenticidadeUrlExibicao}</a>{" "}e informe o código ao lado para confirmar a validade deste documento.</div>;
    $[2] = identificacao.autenticidadeUrl;
    $[3] = identificacao.autenticidadeUrlExibicao;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="text-[9px] font-semibold tracking-[1px] text-neutral-500 uppercase">Código</div>;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== codigoAutenticacao) {
    t5 = <div className="flex-none rounded-[8px] bg-neutral-100 px-4 py-2 text-center">{t4}<div className="text-brand-600 text-[15px] font-bold tracking-[0.5px]">{codigoAutenticacao}</div></div>;
    $[6] = codigoAutenticacao;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t3 || $[9] !== t5) {
    t6 = <div className="px-[37px] pb-[26px]"><div className="border-brand-100 flex flex-wrap items-center gap-[18px] rounded-[12px] border border-solid px-[18px] py-[14px]">{t1}{t3}{t5}</div></div>;
    $[8] = t3;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
}